import { observer } from "mobx-react-lite"

import { ComplexTabsList } from "@/domains/common/components/complex-tabs-list"

import { CL_FARMS_TABS } from "../constants"

export const ClFarmsPageTabs = observer(({ className }: { className?: string }) => {
  return <ComplexTabsList tabs={CL_FARMS_TABS} className={className} />
})
